import { registerComponent, validateZipCode } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-availability-local-delivery",
  class ProductAvailabilityLocalDelivery extends WYATTElement {
    constructor() {
      super();

      this.dataset.loading = "true";
      this.messageContainer = this.querySelector(
        "[data-product-availability='message']",
      );
      this.available = this.dataset.available === "true";
      this.savedZipCode = localStorage.getItem("local_delivery_zip_code");
      this.zipCodeContainer = this.querySelector(
        "[data-product-availability='zip-code']",
      );
      this.drawerButton = this.querySelector(".product-availability__button");

      if (this.savedZipCode) {
        this.renderTemplateWithZipCode();
      } else {
        this.renderTemplateWithoutZipCode();
      }

      this.subscribe(
        window.WYATT.PubSub.events.updateLocalDeliveryZipCode,
        this.handleUpdateLocalDeliveryZipCode.bind(this),
      );
    }

    renderTemplateWithZipCode() {
      this.messageContainer.innerHTML = "Deliverable to";
      this.drawerButton.textContent = "Change";
      this.zipCodeContainer.textContent = this.savedZipCode;
      this.validateZipCode(this.savedZipCode);
      this.dataset.loading = "false";
    }

    renderTemplateWithoutZipCode() {
      this.messageContainer.innerHTML = "Local Delivery";
      this.drawerButton.textContent = "Check availability";
      this.dataset.loading = "false";
      this.removeAttribute("data-available");
    }

    handleUpdateLocalDeliveryZipCode(event) {
      this.savedZipCode = event.detail.zipCode;
      this.renderTemplateWithZipCode();
    }

    validateZipCode(zipCode) {
      const isValid = validateZipCode(zipCode) && this.available;

      if (isValid) {
        this.setAttribute("data-available", "true");
      } else {
        this.setAttribute("data-available", "false");
      }
    }
  },
);
